/**
 * URL utilities.
 * @module utils/url-utils
 */

import { toast } from "vue3-toastify"

/**
 * Get base URL.
 *
 * @return {String} URL
 */
export const getBaseURL = () => {
  const host = process.env.VUE_APP_SABOTEUR_BACKEND_URL

  if (!host) {
    console.warn("VUE_APP_SABOTEUR_BACKEND_URL not set; defaulting to window origin")
    return `${window.location.protocol}//${window.location.host}`
  }

  // If user provides full URL, use it as-is
  if (host.startsWith('http://') || host.startsWith('https://')) {
    return host.replace(/\/+$/, '')
  }

  // Otherwise prepend current protocol
  return `${window.location.protocol}//${host}`.replace(/\/+$/, '')
}

/**
 * Get base URL of REST service.
 *
 * @return {String} URL
 */
export const getBaseApiURL = () => {
  const apiEndpoint = 'api'
  return `${getBaseURL()}/${apiEndpoint}`
}

export const handleApiResponseError = (error) => {
  console.error("Error:", error);

  // Check if response exists and contains data
  if (error.response) {
    console.error("Response Data:", error.response.data);
    console.error("Status Code:", error.response.status);
    console.error("Headers:", error.response.headers);

    // Extracting and displaying detailed error message
    const errorMessage = error.response.data?.detail || "An unexpected error occurred.";
    toast(errorMessage, {
      type: "error",
    });
  } else if (error.request) {
    // If no response received
    console.error("No Response Received:", error.request);
    toast("No response from server. Please check your network.", {
      type: "error",
    });
  } else {
    // Other errors (e.g., request setup issues)
    console.error("Error Message:", error.message);
    toast(error.message, {
      type: "error",
    });
  }
}

